module.exports = __webpack_public_path__ + "img/haukkala_sisalta2.13b11b6e.jpg";